import { render, staticRenderFns } from "./DocumentPatternView.vue?vue&type=template&id=655501b6"
import script from "./DocumentPatternView.vue?vue&type=script&lang=js"
export * from "./DocumentPatternView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports